import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Output, Renderer, TemplateRef, Input } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorService } from '../../../services/proveedor.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-proveedor-modal',
	templateUrl: './proveedor-modal.component.html',
	styleUrls: ['./proveedor-modal.component.css'],
	providers: [ProveedorService, BsModalService]
})
export class ProveedorModalComponent implements OnInit, OnDestroy {
	@Input() pagos_pendientes: boolean;
	@Output() sendProveedor = new EventEmitter();
	public proveedores: Array<Proveedor> = [];
	public selectedRow: Number;
	private proveedor: Proveedor;
	public pagination: Pagination;
	public loading = false;
	private _modelSubscription: Subscription;
	private qs: string;
	constructor(
		public proveedorService: ProveedorService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		private modalService: BsModalService,
	) {
		this.pagination = new Pagination();
		this.qs = "&sort=razon_social";
		this.pagos_pendientes = false;
	}

	ngOnInit() {
		this.getProveedores(this.qs);

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.getProveedores();
		});
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getProveedoresBySearch(text){
		let qs = "&q[dni]=" + text + "&q[razon_social]=" + text + "&q[nombre_comercial]=" + text + "&q[correo]=" + text + "&q[telefono]=" + text + "&q[celular]=" + text;
		this.pagination.current_page = 1;
		this.getProveedores(qs);
	}

	getProveedores(qs = "") {
		this.loading = true;
		if(this.pagos_pendientes){
			qs += "&pagos_pendientes="+this.pagos_pendientes;
		}
		this.proveedorService.getAll('?embed=tipoidentificacion&page='+this.pagination.current_page+'&per_page=10' + qs).subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.proveedores = [];
				} else {
					this.proveedores = res.data;
					
					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
				}
			},	
			err => {
				this.loading = false;
				this.proveedores = [];
			}
		);
	}

	next(){
		this.pagination.current_page++;
		this.getProveedores(this.qs);
	}

	prev(){
		this.pagination.current_page--;
		this.getProveedores(this.qs);
	}

	first(){
		this.pagination.current_page = 1;
		this.getProveedores(this.qs);
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getProveedores(this.qs);
	}

	onSelectRow(proveedor, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de proveedor
		this.proveedor = proveedor;
	}

	onDBLClick(proveedor,i)
	{
		this.onSelectRow(proveedor,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto proveedor
		this.sendProveedor.emit(this.proveedor);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	openModal(template: TemplateRef<any>){
		this.bsModalRef2 = this.modalService.show(template, {class: 'modal-xlg'});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/proveedor-modal/proveedor-modal.component.ts